import { Box } from "@jewlr/storybook/core"
import { motion } from "framer-motion"
import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { IS_NA, jewlr_t } from "helpers/application"

const Path = styled(motion.div).attrs(() => ({
  initial: "hide",
  transition: {
    type: "linear",
  },
  variants: {
    hide: {
      opacity: 0,
      transitionEnd: { display: "none", height: 0 },
    },
    show: {
      display: "block",
      height: "auto",
      opacity: 1,
      transition: { delay: 0.5 },
    },
  },
}))`
  display: none;
  height: 0;
`

const FlashBar = () => {
  // message: shipping info, return policy, ring sizing, warranty)
  // cycles every 3.5 seconds
  // redirects user to proper page on click
  // Link needs to be reconnected when router is setup

  const elements = IS_NA()
    ? [
        [
          `FREE ${jewlr_t("terms.shipping").toUpperCase()} on all orders`,
          "/info/shipping_information",
        ],
        ["99-DAY RETURNS", "/info/returns"],
        ["FREE RESIZING", "/info/ring_sizing"],
        ["ONE-YEAR WARRANTY", "/info/warranty-information"],
      ]
    : [
        [
          `FREE ${jewlr_t("terms.shipping").toUpperCase()} on all orders`,
          "/info/shipping_information",
        ],
        ["99-DAY RETURNS", "/info/returns"],
        ["ONE-YEAR WARRANTY", "/info/warranty-information"],
      ]
  const numFlashItems = elements.length
  const [currentIndex, setCurrentIndex] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentIndex) => (currentIndex + 1) % numFlashItems)
      // setCurrentDisplay(elements[currentIndex])
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <Box fontSize="12px" height="14px" mt="18px">
      {elements.map((el, i) => (
        <Path
          animate={currentIndex === i ? "show" : "hide"}
          initialPose="hide"
          key={`flashbar_${i}`}
        >
          <Link data-lc="flashbar" to={el[1]}>
            {el[0]}
          </Link>
        </Path>
      ))}
    </Box>
  )
}

export default FlashBar
